import { AxiosRequestConfig } from "axios"

export const config = (): AxiosRequestConfig => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('bearer')}`
    },
    validateStatus: (status) => {
      return (status === 200 || status === 201)
    }
  }
}